import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n';
import { Globe } from 'lucide-react';

export function LanguageSwitcher({ variant = 'desktop' }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'pt').slice(0, 2);

  const change = (code) => {
    i18n.changeLanguage(code);
  };

  if (variant === 'mobile') {
    return (
      <div data-testid="language-switcher-mobile" className="px-3 py-2">
        <div className="flex items-center space-x-2 mb-2">
          <Globe className="w-4 h-4 text-[#00FF99]" />
          <span className="text-xs text-zinc-400 uppercase font-bold tracking-wider">{t('language.label')}</span>
        </div>
        <div className="flex items-center space-x-2">
          {SUPPORTED_LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              data-testid={`lang-button-mobile-${lang.code}`}
              onClick={() => change(lang.code)}
              aria-label={`${t('language.aria')}: ${lang.name}`}
              className={`flex-1 text-xs font-bold py-2 rounded-md transition-all ${
                current === lang.code
                  ? 'bg-gradient-to-r from-[#0066FF] to-[#00FF99] text-black shadow-[0_0_12px_rgba(0,255,153,0.4)]'
                  : 'bg-[#1A1A1A] border border-[#27272A] text-zinc-300 hover:border-[#00FF99] hover:text-[#00FF99]'
              }`}
            >
              {lang.label}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="language-switcher"
      role="group"
      aria-label={t('language.aria')}
      className="hidden md:flex items-center bg-[#1A1A1A] border border-[#27272A] rounded-lg p-0.5"
    >
      {SUPPORTED_LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          data-testid={`lang-button-${lang.code}`}
          onClick={() => change(lang.code)}
          aria-pressed={current === lang.code}
          title={lang.name}
          className={`text-xs font-bold px-2.5 py-1.5 rounded-md transition-all ${
            current === lang.code
              ? 'bg-gradient-to-r from-[#0066FF] to-[#00FF99] text-black shadow-[0_0_10px_rgba(0,255,153,0.35)]'
              : 'text-zinc-400 hover:text-white'
          }`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}
